import ApplicationRecord from './ApplicationRecord';
import Reference from './Reference';
import ImageRecord from './ImageRecord';
/**
 * Home page.
 *
 *
 */
export default class ReferencePage extends ApplicationRecord({
  /**
   * @type {Number}
   */
  ID: -1,
  /**
     * @type {String}
     */
  Path: '',
  /**
     * Absolute path.
     * @type {String}
     */
  URL: '',
  /**
     * @type {String}
     */
  Title: '',
  /**
     * @type {Boolean}
     */
  ShowInMenus: false,
  /**
     * @type {Object}
     */
  _embedded: {},
}) {
  /**
     * Get the hero image
     * @return {ImageRecord}
     */
  heroCaption() {
    return '' + this._getOne('HeroText', String);
  }

  /**
     * Get the hero image
     * @return {ImageRecord}
     */
  heroImage() {
    return this._getOne('HeroImg', ImageRecord).set('alt', this.HeroCaption);
  }

  /**
   * Get the hero image for mobile screen
   * @return {ImageRecord}
   */
  heroMobileImage() {
    return this._getOne('HeroMobileImg', ImageRecord).set(
      'alt',
      this.HeroCaption
    );
  }

  /**
   * Get a list of references, dependant of the type
   * @return {List<Chronique>}
   */
  references() {
    return this._getMany(
      'References',
      referenceDoc => new Reference(referenceDoc)
    );
  }
}



// WEBPACK FOOTER //
// ./src/models/ReferencePage.js